import React, { ReactNode } from 'react';
import { ModalHeader } from 'snacks-design-system';

interface componentProps {
  mode?: string;
  heading: ReactNode;
  showBack?: boolean;
  onClose?: () => void;
  onBackClick?: () => void;
}

const PIEModalHeader = (props: componentProps) => {
  return <ModalHeader {...props} />;
};

export default PIEModalHeader;
